import { render, staticRenderFns } from "./VolverEmitir.vue?vue&type=template&id=f622310c&scoped=true"
import script from "./VolverEmitir.vue?vue&type=script&lang=js"
export * from "./VolverEmitir.vue?vue&type=script&lang=js"
import style0 from "./VolverEmitir.vue?vue&type=style&index=0&id=f622310c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f622310c",
  null
  
)

export default component.exports